import script from "./RepairView.vue?vue&type=script&setup=true&lang=js"
export * from "./RepairView.vue?vue&type=script&setup=true&lang=js"

import "./RepairView.vue?vue&type=style&index=0&id=8ffdc30a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ffdc30a"]])

export default __exports__